<template>
  <div class="c-box mb-16 mt-px">
    <div class="p-pnt">
      <div class="menu-main-content">
        <section>
          <div class="main-top">
            <div class="main-top-left">
              <a
                class="inline-flex items-center"
                href="javascript:void(0)"
                @click="backPath"
              >
                <i class="icon icon-bor-arrow-left pr-2" style="font-size: 10px" />
                <span class="text-black">プラン一覧に戻る</span>
              </a>
            </div>
            <div class="main-top-right lg:hidden">
              <a href="#intro" v-smooth-scroll="{ offset: -20 }">
                <button class="c-btn btn-white btn-sm">
                  <i class="icon icon-bor-circle-question pr-2" />
                  <span>ご利用方法</span>
                </button>
              </a>
            </div>
          </div>
        </section>

        <!-- /* Carousel */ -->
        <section class="lg:pl-4">
          <div class="pnl-title flex items-start">
            <div class="label label-primary mt-2 mr-4" v-if="checkFiveDay()">NEW</div>
            <h3 class="two-lines-ellipsis" v-if="planBasicInfo">
              {{ planBasicInfo.planNm }}
            </h3>
          </div>
          <div class="main-demo">
            <div class="menu-carousel">
              <BasicCarousel
                class="mb-4 lg:hidden"
                :isShowIndicator="false"
                :images="get(planBasicInfo, 'slides', [])"
              />

              <div
                class="slide-images-mobile hidden lg:flex overflow-x-auto object-contain"
                v-if="planBasicInfo && planBasicInfo.slides.length > 0"
              >
                <img
                  :src="img.imageUrl"
                  :alt="img.imageExplanation"
                  v-for="(img, idx) in planBasicInfo.slides"
                  :key="`plan-img-${idx}`"
                />
              </div>
              <a class="menu-carousel_link" @click="showPhotoGallery">
                フォトギャラリーを見る
                <i
                  class="icon icon-bor-arrow-right text-primary text-sm pl-2 leading-none"
                />
              </a>
            </div>
            <div class="menu-calendar">
              <div class="coupons-meta -mb-4">
                <div
                  class="recommended-right flex inline-flex"
                  v-for="(flag, index) in getUsageDetails"
                  :key="`usage-flag-${index}`"
                >
                  <Tag size="small" class="mr-1" v-if="flag.label">
                    {{ flag.label }}
                  </Tag>
                </div>
              </div>
              <div>
                <Tag size="middle" class="font-bold text-primary hidden">
                  ベネポ1%付与
                </Tag>
              </div>

              <a>
                <button class="c-btn btn-reserve w-full" @click="orderTour">
                  お申し込みはこちら
                </button>
              </a>

              <div class="menu-calendar_expire">
                <p>
                  予約受付締切日:
                  <span v-if="getPlanRc">
                    {{ getPlanRc }}
                  </span>
                </p>
              </div>

              <div class="menu-calendar_menberInfo">
                お申込みの際は、会員である旨と会員IDをお伝えください。
              </div>
              <div class="menu-calendar_paymentInfo">
                サービス提供企業へお支払いください。
              </div>

              <p class="menu-calendar_id" v-if="planBasicInfo && planBasicInfo.planId">
                プランID:{{ planBasicInfo.planId }}
              </p>
              <div>
                <ul>
                  <li>●いかなるラ・クーポンも使用・併用はできません。</li>
                  <li>
                    ●ラ・クーポンをお使いになりたい場合は、会員専用サイトを経由せずにお申込みください。
                  </li>
                  <li>
                    ただし、その場合カフェテリアプランポイントのご利用とベネポのプレゼントはできません。
                  </li>
                  <li>
                    【カフェテリアプランポイント・補助金のご利用について】
                  </li>
                  <li>
                    カフェテリアプランポイント・補助金は年度をまたいだご旅行や次年度出発のご旅行には本年度のカフェテリアポイント・補助金は適用できません。
                  </li>
                  <li>
                    カフェテリアプランポイント・補助金は年度内出発及び到着の日程でご利用ください。
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="divider mb-8 mt-8 sm:mt-0" />
        </section>

        <!-- Room Detail -->
        <section>
          <div class="room-detail mb-4">
            <SectionContentTitle lineType="v-line" titleContent="プランリード" />
            <div
              v-if="getPlanLeadCopy"
              v-html="getPlanLeadCopy.replaceAll('\n', '<br>')"
            ></div>
          </div>
        </section>

        <section>
          <div class="room-detail">
            <SectionContentTitle lineType="v-line" titleContent="特典" />
            <div
              class="mb-4"
              v-if="getBenefitImportantPoints"
              v-html="getBenefitImportantPoints.replaceAll('\n', '<br>')"
            />
            <div class="menu-price flex mb-4">
              <div class="price-content">
                <p class="text-black" v-if="getBenefitHeading">{{ getBenefitHeading }}</p>
                <span
                  class="font-bold"
                  v-if="getBenefitContent"
                  v-html="getBenefitContent.replaceAll('\n', '<br>')"
                />
              </div>
            </div>
          </div>
        </section>
      </div>
      <!-- Image Preview -->
      <Modal
        :visible="showPreviewImg"
        size="large"
        @cancel="showPreviewImg = false"
        @ok="showPreviewImg = false"
      >
        <div class="w-full" v-if="previewImage">
          <img :src="previewImage.imageUrl" class="image-preview" />
        </div>
      </Modal>
      <InstructionLogin
        :description1="description1"
        :description2="description2"
        :visible="popupLogin"
        @ok="popupLogin = false"
        @cancel="popupLogin = false"
      />
    </div>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars */
/* eslint-disable no-irregular-whitespace */
/* eslint-disable vue/no-side-effects-in-computed-properties */
/* eslint-disable vue/no-unused-components */
import moment from 'moment'
import _ from 'lodash'
import get from 'lodash/get'
import plan_utils from '@/mixins/plan_utils'
import func_utils from '@/mixins/func_utils'
import {
  MenuNavigation,
  CarouselThumbnail,
  BoxViewMore,
  SectionContentTitle
} from '@/components/compound'
import { Button, Tag, Calendar, Stepper, Modal } from '@/components/primitive'
import { SAVE_CUSTOMER_PLAN, SAVE_PLAN_DETAIL } from '@/store/modules/plan/actions'
import { getCookieValue } from '@/utils/cookie'
const PLACEHOLDER_IMG = require('@/assets/images/slide-img-placeholder.png')
import { GET_MENU_BASIC_INFO } from '@/store/modules/menu/actions'

export default {
  name: 'PlanDetail',
  mixins: [plan_utils, func_utils],
  components: {
    Button,
    BoxViewMore,
    Calendar,
    CarouselThumbnail,
    MenuNavigation,
    Tag,
    Stepper,
    SectionContentTitle,
    Modal
  },
  data() {
    return {
      acptDtlNo: null,
      loading: false,
      showPreviewImg: false,
      previewImage: [
        {
          imageUrl: '',
          imageExplanation: ''
        }
      ],
      dateFormat: 'YYYY/MM/DD',
      planDetail: null,
      menuInformation: null,
      planBasicInfo: null,
      roomIcons: null,
      planInfomation: null,
      roomBasicInfo: null,
      status: null,
      planRcSttDt: null,
      showGallery: false,
      galleryData: [],
      isLoginedRakuten: false,
      memberBenefits: null,
      benefitImportantPoints: null,
      popupLogin: false,
      planUsage: null,
      menuBasicInfo: null,
      description1: 'ログインして',
      description2: 'サービスをご利用ください。'
    }
  },
  async created() {
    const bsjsessionid = getCookieValue(process.env.VUE_APP_SSO_COOKIE_NAME);
    this.status = bsjsessionid.slice(0, 2);
    const { menuNo, planId, roomId } = this.$route.params
    const query = this.$route.query
    this.loadInitData()
    this.$loading.show()
    const results = await Promise.all([this.getPlanDetail(), this.getMenuBasicInfo()])
    this.$loading.hide()
    const planResult = results[0]
    const menuBasicResults = results[1]
    this.menuBasicInfo = menuBasicResults
    if (!planResult || planResult.error) {
      this.$page.errorHandler(planResult, { navigate: true })
      return
    }
    this.$store.dispatch(SAVE_PLAN_DETAIL, planResult)
    this.planDetail = planResult
    this.menuInformation = this.planDetail.menuInformation
    this.planBasicInfo = this.planDetail.planBasicInfo
    if (this.planBasicInfo) {
      if (
        !Array.isArray(this.planBasicInfo.planImages) ||
        !this.planBasicInfo.planImages.length
      ) {
        this.planBasicInfo.planImages = [
          {
            imageUrl: PLACEHOLDER_IMG,
            imageExplanation: ''
          }
        ]
      }
      for (let i = 0; i < this.planBasicInfo.planImages.length; i++) {
        if (
          this.planBasicInfo.planImages &&
          (this.planBasicInfo.planImages[i].imageUrl === '' ||
            this.planBasicInfo.planImages[i].imageUrl === null)
        ) {
          this.planBasicInfo.planImages[i].imageUrl = PLACEHOLDER_IMG
        }
      }
      this.planBasicInfo.slides = this.planBasicInfo.planImages.map((item) => {
        return {
          imageUrl: item.imageUrl,
          label: item.imageExplanation
        }
      })
    }
    this.planRcSttDt = this.planDetail.planBasicInfo.planRcSttDt
    this.planInfomation = this.planDetail.planInfomation
    this.planUsage = this.planDetail.planUsage
  },
  mounted() {},
  watch: {},
  computed: {
    loggedIn() {
      // return true
      return this.$auth.loggedIn
    },
    loggedRakuten() {
      return this.$auth.loggedRakuten
    },
    userInfo() {
      return this.$store.getters['auth/get'].user
    },
    getCustomerPlan() {
      return this.$store.getters.customerPlan
    },
    planImagePreview() {
      const planImage = _.get(this.planBasicInfo, 'planImages[0].imageUrl', null)
      if (planImage) {
        return planImage
      }
      return PLACEHOLDER_IMG
    },
    getUsageDetails() {
      const planIcons = _.get(this.planDetail, 'planIcons', null)
      const activeFlags = Object.keys(planIcons || {}).map((key) => {
        return {
          label: _.get(planIcons[key], 'iconNm', null),
          value: _.get(planIcons[key], 'iconNm', null)
        }
      })
      return activeFlags
    },
    getPlanRc() {
      const formatDate = 'YYYY年MM月DD日'
      const planRcSttDt = _.get(this.planBasicInfo, 'planRcSttDt', '')
      const planRcEndDt = _.get(this.planBasicInfo, 'planRcEndDt', '')
      const startDt = planRcSttDt ? moment(planRcSttDt).format(formatDate) : ''
      const endDt = planRcEndDt ? moment(planRcEndDt).format(formatDate) : ''
      return [startDt, endDt].filter(Boolean).join('~')
    },
    getPlanLeadCopy() {
      const planLeadCopy = _.get(this.planBasicInfo, 'planLeadCopy', '')
      return planLeadCopy
    },
    getBenefitImportantPoints() {
      const getBenefitImportantPoints = _.get(
        this.planDetail,
        'benefitImportantPoints[0].content',
        ''
      )
      return getBenefitImportantPoints
    },
    getBenefitHeading() {
      const benefitHeading = _.get(this.planDetail, 'memberBenefits[0].benefitHeading')
      return benefitHeading
    },
    getBenefitContent() {
      const benefitContent = _.get(this.planDetail, 'memberBenefits[0].benefitContent')
      return benefitContent
    }
  },
  methods: {
    get,
    loadInitData() {
      const query = _.cloneDeep(this.$route.query)
      if (query.isLoginedRakuten) {
        this.isLoginedRakuten = true
      }
      if (!query.adultHeadCnt) {
        query.adultHeadCnt = 1
      }
    },
    async orderTour() {
      if (!this.loggedIn) {
        this.popupLogin = true
        return
      }
      const extSystemCd = this.menuBasicInfo?.extSystemCd
      let orderSite = null
      if (extSystemCd === 'rtdp') {
        orderSite = '1'
      } else if (extSystemCd === 'andp') {
        orderSite = '2'
      } else if (extSystemCd === 'jadp' || extSystemCd === 'jato') {
        orderSite = '3'
      }
      const { menuNo, planId } = this.$route.params
      const data = {
        customerNo: _.get(this.userInfo, 'ssoCustomerNo', null),
        menuNo,
        planId,
        orderSite
      }

      const orderTour = await this.checkOrderTour(data)
      if(orderTour.status === 200) {
        location.href = orderTour.data
      } else {
        this.$toasted.error('エラーが発生しました。')
      }
    },

    async checkOrderTour(data) {
      return await this.$repositories('order')
        .checkOrderTour(data)
        .then(
          (result) => result,
          (error) => error
        )
    },

    async getPlanDetail() {
      const { menuNo, planId } = this.$route.params
      const query = this.$route.query
      return await this.$repositories('plan')
        .getPlanDetailTour(menuNo, planId, query)
        .then(
          (result) => result,
          (error) => error
        )
    },
    async getMenuBasicInfo() {
      const { menuNo } = this.$route.params
      return await this.$store.dispatch(GET_MENU_BASIC_INFO, { menuNo }).then(
        (result) => result,
        (error) => error
      )
    },
    async getAcptDtlNo() {
      this.$repositories('order')
        .getOrderAcptDtlNo()
        .then((response) => {
          this.acptDtlNo = response.acptDtlNo
        })
    },
    checkFiveDay() {
      const countDay = moment().diff(moment(this.planRcSttDt, 'DD/MM/YYYY'), 'days')
      if (countDay > 0 && countDay <= 5) {
        return true
      }
      return false
    },
    showPhotoGallery() {
      const { menuNo } = this.$route.params
      const query = this.$route.query
      this.$router.push({ path: `/menus/${menuNo}/photo-gallery`, query })
    },
    backPath() {
      const { menuNo } = this.$route.params
      const query = this.$route.query
      this.$router.push({ path: `/menus/${menuNo}/plans`, query })
    },
    previewPlanImage(imgInfo) {
      if (imgInfo) {
        this.previewImage = imgInfo
        this.showPreviewImg = true
      }
    },
    copyShareURL() {
      return location.href
    },
    copySuccess() {
      this.$toasted.success('コピーしました')
    },
    copyError() {
      this.$toasted.error('コピーできません')
    },
    handleOpenIntro() {
      window.open(
        `${process.env.VUE_APP_BS_BENEFIT_DOMAIN}/bs/pages/bo/template.faces?ih=/contents/bs_base/goriyou/`
      )
    },
    openTaxLink() {
      const { menuNo } = this.$route.params
      window.open(
        `${process.env.VUE_APP_BS_BENEFIT_DOMAIN}/bs/pages/bs/stay/stayTax.faces?menuNo=${menuNo}`
      )
    },
    savePlanData(callback = null) {
      const data = {
        acptDtlNo: this.acptDtlNo,
        extSystemCd: _.get(this.menuInformation, 'extSystemCd', null)
      }
      this.$store.dispatch(SAVE_CUSTOMER_PLAN, data).then(() => {
        if (callback) {
          callback()
        }
      })
    },
    async goNext() {
      const query = this.$route.query
      const queryParams = {
        ...this.$route.params,
        ...query
      }

      this.savePlanData(() => {
        this.$router.push({ path: '/register-rooms', query: queryParams })
      })
    },
    loginRakuten() {
      const urlPage = window.location.href
      //location.href = `https://app.rakuten.co.jp/engine/authorize?response_type=code&client_id=rakutentravel_beneone&redirect_uri=https://bs-stay-test.sbworks.jp/api/oauth/rakuten/callback?url=${urlPage}&scope=travel_booking_book,travel_booking_cancel,travel_booking_refer,1Hour@Access&service_id=t22`
      location.href = `${process.env.VUE_APP_RAKUTEN_LOGIN_DOMAIN}/sso/authorize?response_type=code&client_id=rakutentravel_beneone_jp&redirect_uri=${process.env.VUE_APP_API_URL}/v1/stay/rakuten/login&state=${urlPage}&scope=openid+travel_booking_book+travel_booking_cancel+travel_booking_refer&service_id=t22&ui_locales=ja-JP`
    }
  }
}
</script>

<style lang="scss" scoped>
@import './styles.scss';
</style>
